import { Grid } from "@mui/material";
import Bouton from "../../../../components/Button/Bouton";
import UncontrolledInputField from "../../../../components/input/UncontrolledInputField";
import InputCheckbox from "../../../../components/inputCheckbox/InputCheckbox";

interface Props {
  onChangeCritere(critere: string | number, value: string | boolean): void;
  onRechercher(): void;
  initialValues: { [key: string]: any };
}

function CriteresRecherche({
  onChangeCritere,
  onRechercher,
  initialValues,
}: Props) {
  const handleUpdateCritere = (id: string, value: string) => {
    onChangeCritere(id, value);
  };

  const handleUpdateCritereCheckBox = (id: number | string, event: boolean) => {
    onChangeCritere(id, event);
  };
  /**
   * Fonction permettant de déclencher la recherche.
   */
  const handleRechercher = () => {
    onRechercher();
  };

  return (
    <Grid
      container
      spacing={2}
      justifyContent="space-between"
      className={"formRechercherAdb fondGrisFonce"}
    >
      <Grid item xs={3}>
        <UncontrolledInputField
          id="numAdherent"
          label="Identifiant adhérent"
          handleChange={handleUpdateCritere}
          type="number"
          size={7}
          max={9999999}
        />
      </Grid>
      <Grid item xs={3}>
        <UncontrolledInputField
          id="nomAdherent"
          label="Nom adhérent"
          handleChange={handleUpdateCritere}
        />
      </Grid>
      <Grid item xs={3}>
        <UncontrolledInputField
          id="commercial"
          label="Nom du commercial"
          handleChange={handleUpdateCritere}
        />
      </Grid>
      <Grid item xs={3}>
        <UncontrolledInputField
          id="departement"
          label="Département"
          handleChange={handleUpdateCritere}
        />
      </Grid>
      <Grid item xs={3}>
        <UncontrolledInputField
          id="codePostal"
          label="Code postal"
          handleChange={handleUpdateCritere}
        />
      </Grid>
      <Grid item xs={3}>
        <UncontrolledInputField
          id="ville"
          label="Ville"
          handleChange={handleUpdateCritere}
        />
      </Grid>
      <Grid item xs={3}>
        <InputCheckbox
          input={{
            name: "actif",
            value: initialValues.actif,
            onBlur: () => {},
            onChange: () => {},
            onFocus: () => {},
          }}
          meta={{}}
          id="actif"
          name="actif"
          value={initialValues.actif}
          label="Actif"
          onChangeValue={handleUpdateCritereCheckBox}
        />
      </Grid>
      <Grid item className={"bouton"} xs={3}>
        <Bouton
          label="Rechercher"
          variant="contained"
          color="primary"
          size="medium"
          onClick={handleRechercher}
        />
      </Grid>
    </Grid>
  );
}

export default CriteresRecherche;
